import { Component, OnInit } from '@angular/core';
import { Funds_Interface } from 'src/app/Interface/Funds_Interface';
import { LetterRequestCustomer_Funds_Interface } from 'src/app/Interface/LetterRequestCustomer_Funds_Interface';
import { FundsService } from 'src/app/Service/Funds/Funds.service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-FundsUser',
  templateUrl: './FundsUser.component.html',
  styleUrls: ['./FundsUser.component.scss']
})
export class FundsUserComponent implements OnInit {


  Token: String = ""
  InProccessing: boolean = false
  page_Charge: any
  page_Pay: any
  BaseUrl = environment.BaseUrl

  DataList_Funds_Charge: Array<Funds_Interface> = []
  DataList_Funds: Array<LetterRequestCustomer_Funds_Interface> = []

  constructor(
    private Funds_Service: FundsService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.ReadData_Funds()
  }


  ReadData_Funds() {
    this.InProccessing = true
    this.Funds_Service.GetDetailUser(this.Token).subscribe(
      data => {
        this.DataList_Funds_Charge = data['charge']
        this.DataList_Funds = data['pay']
        this.InProccessing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  exportexcel_Funds_Charge(): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table-charge');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, "BehfaFund.xlsx");

  }

  exportexcel_Funds(): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, "BehfaFund.xlsx");

  }

}
